import { render, staticRenderFns } from "./MetaClosingMeeting.vue?vue&type=template&id=25e8a8a3&scoped=true&"
import script from "./MetaClosingMeeting.vue?vue&type=script&lang=ts&"
export * from "./MetaClosingMeeting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e8a8a3",
  null
  
)

export default component.exports